package lacaravana.ui

import kotlinx.browser.document
import kotlinx.coroutines.launch
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import lacaravana.app.Database
import lacaravana.app.appScope
import lacaravana.domain.Stock

object StockView {
    suspend fun render(db: Database) {
        val content = document.getElementById("content") ?: return
        content.innerHTML = ""
        val items = Stock.all(db)

        content.append {
            h2 { +"Stock" }
            if (items.isEmpty()) {
                p { +"No hay items en el menú" }
            } else {
                table {
                    thead { tr { th { +"Producto" }; th { +"Cantidad" }; th { +"Acciones" } } }
                    tbody {
                        for (item in items) {
                            tr {
                                attributes["data-stock-item"] = item.nombre
                                td { +item.nombre }
                                td {
                                    span {
                                        classes = setOf("stock-qty")
                                        +item.cantidad.toString()
                                    }
                                }
                                td {
                                    button {
                                        attributes["data-action"] = "decrease"
                                        +"-"
                                        onClickFunction = {
                                            appScope.launch {
                                                Stock.adjust(db, item.menuItemId, -1)
                                                render(db)
                                            }
                                        }
                                    }
                                    button {
                                        attributes["data-action"] = "increase"
                                        +"+"
                                        onClickFunction = {
                                            appScope.launch {
                                                Stock.adjust(db, item.menuItemId, 1)
                                                render(db)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
